import React from 'react';
import { Reveal } from './Reveal';
export const AlternativeCostsSection = () => {
  return <section className="py-12 md:py-20 px-[5vw] bg-white" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <Reveal data-id="element-13">
          <div className="text-center mb-10 md:mb-14" data-id="element-14">
            <h2 className="font-serif font-bold text-[clamp(32px,5vw,48px)] tracking-[-0.02em] text-ink mb-4 leading-tight" data-id="element-15">
              Faz a conta comigo.
            </h2>
            <p className="text-[15px] md:text-[17px] text-ink-soft max-w-lg mx-auto" data-id="element-16">
              Pra ter clareza dos seus números hoje, quais são as suas opções?
            </p>
          </div>
        </Reveal>

        <div className="space-y-4 md:space-y-5 mb-12" data-id="element-17">
          {/* Option 1 */}
          <Reveal delay={0.1} data-id="element-18">
            <div className="bg-white border border-line rounded-xl p-3.5 md:p-4 shadow-sm flex flex-col md:flex-row md:items-center gap-3 md:gap-4 grayscale-[0.3]" data-id="element-19">
              <div className="flex items-center gap-3 flex-1" data-id="element-20">
                <div className="w-10 h-10 rounded-full bg-ink/5 flex items-center justify-center text-xl flex-shrink-0" data-id="element-21">
                  👩‍💼
                </div>
                <div data-id="element-22">
                  <h3 className="font-semibold text-ink text-[14px] md:text-[15px]" data-id="element-23">
                    Contadora que entende do seu negócio
                  </h3>
                  <p className="text-[12px] md:text-[13px] text-ink-soft mt-0.5" data-id="element-24">
                    E ainda não conhece o seu brigadeiro.
                  </p>
                </div>
              </div>
              <div className="md:text-right pl-[52px] md:pl-0" data-id="element-25">
                <div className="inline-block bg-ink/5 text-ink-soft font-bold text-[13px] md:text-[14px] px-2.5 py-1 rounded-lg line-through decoration-ink/30 decoration-2" data-id="element-26">
                  R$ 250 a R$ 600 /mês
                </div>
              </div>
            </div>
          </Reveal>

          {/* Option 2 */}
          <Reveal delay={0.2} data-id="element-27">
            <div className="bg-white border border-line rounded-xl p-3.5 md:p-4 shadow-sm flex flex-col md:flex-row md:items-center gap-3 md:gap-4 grayscale-[0.3]" data-id="element-28">
              <div className="flex items-center gap-3 flex-1" data-id="element-29">
                <div className="w-10 h-10 rounded-full bg-ink/5 flex items-center justify-center text-xl flex-shrink-0" data-id="element-30">
                  🖥️
                </div>
                <div data-id="element-31">
                  <h3 className="font-semibold text-ink text-[14px] md:text-[15px]" data-id="element-32">
                    Sistema de gestão de empresa
                  </h3>
                  <p className="text-[12px] md:text-[13px] text-ink-soft mt-0.5" data-id="element-33">
                    Cheio de aba que você não usa, feito pra quem tem CNPJ e
                    equipe.
                  </p>
                </div>
              </div>
              <div className="md:text-right pl-[52px] md:pl-0" data-id="element-34">
                <div className="inline-block bg-ink/5 text-ink-soft font-bold text-[13px] md:text-[14px] px-2.5 py-1 rounded-lg line-through decoration-ink/30 decoration-2" data-id="element-35">
                  R$ 100 a R$ 300 /mês
                </div>
              </div>
            </div>
          </Reveal>

          {/* Option 3 */}
          <Reveal delay={0.3} data-id="element-36">
            <div className="bg-white border border-line rounded-xl p-3.5 md:p-4 shadow-sm flex flex-col md:flex-row md:items-center gap-3 md:gap-4 grayscale-[0.3]" data-id="element-37">
              <div className="flex items-center gap-3 flex-1" data-id="element-38">
                <div className="w-10 h-10 rounded-full bg-ink/5 flex items-center justify-center text-xl flex-shrink-0" data-id="element-39">
                  🎓
                </div>
                <div data-id="element-40">
                  <h3 className="font-semibold text-ink text-[14px] md:text-[15px]" data-id="element-41">
                    Curso de precificação
                  </h3>
                  <p className="text-[12px] md:text-[13px] text-ink-soft mt-0.5" data-id="element-42">
                    Te ensina a pensar, mas não vira ferramenta. Na semana
                    seguinte você tá no chute de novo.
                  </p>
                </div>
              </div>
              <div className="md:text-right pl-[52px] md:pl-0" data-id="element-43">
                <div className="inline-block bg-ink/5 text-ink-soft font-bold text-[13px] md:text-[14px] px-2.5 py-1 rounded-lg line-through decoration-ink/30 decoration-2" data-id="element-44">
                  R$ 300 a R$ 2.000
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        {/* Transition Line */}
        <Reveal delay={0.5} data-id="element-45">
          <div className="bg-rose-soft/50 border border-rose/20 rounded-3xl p-6 md:p-8 text-center shadow-sm relative overflow-hidden" data-id="element-46">
            <div className="absolute -top-10 -right-10 w-32 h-32 bg-rose/10 rounded-full blur-2xl" data-id="element-47"></div>
            <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-gold/10 rounded-full blur-2xl" data-id="element-48"></div>

            <p className="text-[15px] md:text-[17px] leading-relaxed text-ink relative z-10" data-id="element-49">
              A Aurora não é nenhuma dessas. Ela é a{' '}
              <strong className="text-rose font-bold" data-id="element-50">ferramenta</strong>.
              Simples, no seu celular, feita pra você.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
};